import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { InputFieldComponent } from '../../ui/inputField/inputField.component';
import { CustomizableButtonComponent } from '../../ui/customizable-button/customizable-button.component';
import { ModalFormContainerComponent } from '../../ui/modal-form-container/modal-form-container.component';
import { ReactiveFormsModule, Validators, FormBuilder } from '@angular/forms';
import { ContactsService } from '../../../services/contacts/contacts.service';
import { ITag } from '../../../types/contactModule';

@Component({
  selector: 'edit-tag-modal',
  standalone: true,
  imports: [InputFieldComponent, CustomizableButtonComponent, ModalFormContainerComponent, ReactiveFormsModule],
  templateUrl: './edit-tag-modal.component.html',
  styleUrls: ['../../tables/group-table/group-form.css', './edit-tag-modal.component.css'],
})
export class EditTagModalComponent implements OnChanges {
  @Output() closeModal = new EventEmitter();
  @Input({ required: true }) selectedTag!: ITag | null;
  @Input({ required: true }) modalOpen!: boolean;

  // reactive data
  submitted: boolean = false;
  open: boolean = false;
  saveError = '';
  // services
  contactsService = inject(ContactsService);
  builder = inject(FormBuilder);

  tagForm = this.builder.group({
    name: ['', [Validators.required, Validators.minLength(2)]],
    description: [''],
  });

  get nameError(): string {
    const control = this.tagForm.controls.name;
    if (!this.submitted || control.valid) return '';
    return control.hasError('required') ? 'Enter a name for the tag' : 'Use at least 2 characters';
  }

  close() {
    this.closeModal.emit();
  }

  get contactServiceLoading() {
    return this.contactsService.isLoading;
  }

  handleSubmit() {
    this.submitted = true;
    this.saveError = '';
    if (this.tagForm.valid) {
      this.contactsService
        .updateTag({ ...this.selectedTag, ...(this.tagForm.value as ITag) }, this.selectedTag?.uuid as string)
        .subscribe({
          next: () => {
            this.close();
          },
          error: () => {
            this.saveError = 'Your changes were not saved. Check your connection and try again.';
          },
        });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const opening = !!changes['modalOpen'] && this.modalOpen && !changes['modalOpen'].previousValue;
    if (changes['selectedTag'] || opening) {
      this.tagForm.reset({
        name: this.selectedTag?.name ?? '',
        description: this.selectedTag?.description ?? '',
      });
      this.submitted = false;
      this.saveError = '';
    }
    this.open = this.modalOpen;
  }
}
